import { Link } from "react-router-dom";
import { categories } from "../data/products";
import { ui, useLang } from "../i18n/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#0B1F3A] text-white mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 border border-white/60 flex items-center justify-center">
                <div className="w-2 h-2 bg-white" />
              </div>
              <div>
                <div className="text-[15px] font-semibold">{t(ui.brand)}</div>
                <div className="mono text-[10px] tracking-[0.2em] uppercase text-white/60">
                  {t(ui.tagline)}
                </div>
              </div>
            </div>
            <p className="text-sm text-white/70 max-w-xs leading-relaxed">
              {t(ui.footer.desc)}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="mono text-[11px] tracking-[0.2em] uppercase text-white/50 mb-5">
              {t(ui.footer.nav)}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="hover:text-white/70 transition" data-testid="footer-nav-home">
                  {t(ui.nav.home)}
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white/70 transition" data-testid="footer-nav-about">
                  {t(ui.nav.about)}
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-white/70 transition" data-testid="footer-nav-products">
                  {t(ui.nav.products)}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white/70 transition" data-testid="footer-nav-contact">
                  {t(ui.nav.contact)}
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="mono text-[11px] tracking-[0.2em] uppercase text-white/50 mb-5">
              {t(ui.footer.cats)}
            </div>
            <ul className="space-y-3 text-sm">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/products?category=${c.slug}`}
                    className="hover:text-white/70 transition"
                    data-testid={`footer-cat-${c.slug}`}
                  >
                    {t(c.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="mono text-[11px] tracking-[0.2em] uppercase text-white/50 mb-5">
              {t(ui.footer.contact)}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="mailto:Info@azroil.az" className="hover:text-white/70" data-testid="footer-email">
                  Info@azroil.az
                </a>
              </li>
              <li>
                <a href="tel:+994552543444" className="hover:text-white/70" data-testid="footer-phone">
                  +994 55 254 34 44
                </a>
              </li>
              <li className="text-white/70">{t(ui.contact.items.officeValue)}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="mono text-[11px] tracking-[0.2em] uppercase text-white/50">
            © {new Date().getFullYear()} Az.r.Oil — {t(ui.footer.rights)}
          </div>
          <div className="mono text-[11px] tracking-[0.2em] uppercase text-white/50">
            {t(ui.footer.tag)}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
